import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-po-finish-prod-comp-qty',
  templateUrl: './po-finish-prod-comp-qty.component.html',
  styleUrls: ['./po-finish-prod-comp-qty.component.css']
})
export class PoFinishProdCompQtyComponent implements OnInit {
    p2PoFinishProdCompKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.p2PoFinishProdCompKeyno = this.stateService.getStateParams()['p2_pofinishprodcomp_keyno'];
    }

    private async loadEdit() {
        if (!!this.p2PoFinishProdCompKeyno) {
            this.edit = (await this.datatask.Post(167, { p2_pofinishprodcomp_keyno: this.p2PoFinishProdCompKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(182, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    p2_pofinishprodcomp_keyno: string;
    prod_id: string;
    prod_name: string;
    prodsize_keyno: string;
    prodchoice_keyno: string;
    quantity: string;
    stock_keyno: string;
    quantity_picked: string;
    quantity_topick: string;
    prodname_long_top: string;
    show_button_pofinishprodcompassign: string;
    nbr_of_stockbatches_assigned: string;
}
